@if (steps?.length) {
  <div class="ap-progress" role="list" aria-label="Status wniosku" [@list]="steps?.length || 0">
    @for (s of steps; track trackByKey(i, s); let i = $index; let first = $first; let last = $last) {
      <div class="ap-step" role="listitem" [@step] [@.disabled]="first || last" [class.ap-step--edge]="first || last"
        [class.ap-step--rejected]="s.state==='rejected'" [matTooltip]="s.tooltip || ''">
            <mat-icon class="ap-ico" [ngClass]="{
                'ap-ico--done': s.state==='done',
                'ap-ico--wait': s.state==='wait',
                'ap-ico--inactive-wait': s.state === 'inactiveWait',
                'ap-ico--cancelled': s.state==='cancelled',
                'ap-ico--rejected': s.state==='rejected'
                }">
          @switch (s?.state) {
            @case ('done') { check }
              @case ('rejected') { close }
                @case ('cancelled') { not_interested }
                  @default { hourglass_empty }
                  }
                </mat-icon>
                <span class="ap-label">{{ isBaseStep(s.key) ? (s.label | translate) : s.label }}</span>
              </div>
              @if (!last) {
                <div class="ap-connector" aria-hidden="true"
                  [class.ap-connector--static]="initialRender && isBaseStep(s.key) && isBaseStep(steps[i + 1]?.key)"
                  [@connector] [@.disabled]="initialRender && isBaseStep(s.key) && isBaseStep(steps[i + 1]?.key)">
                </div>
              }
            }
          </div>
        }